import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import {
  InputGroup,
  FieldWrappers,
  Label,
  SubmitBtn,
  SideCancelBtn,
  Wrapper,
  ScrollableContent,
  ActionSection,
  MobileIcon,
} from "../Styles/InputStyles";
import { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import CategoryCard from "../CategoryCard";
import SelectItemModal from "../SelectItemModal";
import { useMemo } from "react";
import { MdEdit, MdAddLocationAlt } from "react-icons/md";
import SelectLocationModal from "../SelectLocationModal";
import { useSelector } from "react-redux";
import tw from "tailwind-styled-components";

const LinkStaff = ({
  onClose,
  // staffList,
  selectedData,
  handleClose,
  setShowAddLocation,
  addAssignedStaffLoading,
  addAssignedStaffMutate,
  staffList
}) => {
  // const staffList = useSelector((state) => state.StaffReducer.staffs)
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [isStaffModalOpen, setIsStaffModalOpen] = useState(false);
  const [height, setHeight] = useState(window.innerHeight);
  const [timeOption, setTimeOption] = useState("any");
  const [restrictedTimes, setRestrictedTimes] = useState("");
  const timeSlots = [ "10:00 AM-12:00 PM","1:00 PM-3:00 PM", "4:00 PM-6:00 PM"];

  const [showLocationModal, setShowLocationModal] = useState(false);

const locations = useSelector(
  (state) => state.LocationsReducer.locations
);

const filteredLocations = useMemo(
  () => locations?.filter(l => l.id !== 0) || [],
  [locations]
);

  useEffect(() => {
    const handleResize = () => setHeight(window.innerHeight);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

   const initialValues = {
    staffName: "",
    ownerId: "",
    mobile: "",
    locationId: "",
    timeOption: "any",        
    restrictedTimes: [],       
    notes: "",                
   };

   const validationSchema = Yup.object({
  staffName: Yup.string()
    .required("Staff selection is required"),

  ownerId: Yup.number()
    .required("Staff ID is required"),

  mobile: Yup.string()
    .required("Mobile number is required")
    .matches(/^[0-9]{10}$/, "Mobile number must be exactly 10 digits"),

  locationId: Yup.number()
    .nullable(),

  restriction: Yup.string().when([], {
    is: () => timeOption === "restriction",
    then: (schema) =>
      schema.required("Please enter visiting time restriction"),
    otherwise: (schema) => schema.nullable(),
  }),

  notes: Yup.string()
    .max(200, "Notes cannot exceed 200 characters")
    .nullable(),
});

const handleSubmit = (values, { setSubmitting, resetForm }) => {
  const payload = {
    inventoryId: selectedData.inventoryId,
    assignedStaffId: values.ownerId,
    mobile: values.mobile,
    // locationId: values.locationId || null,
    timeOption: timeOption,
    visitSlot: timeOption === "restriction" ? values.restriction : null,
    note: values.notes,
    dealId: selectedData.id,
  };

  addAssignedStaffMutate(payload);
  setSubmitting(false);
  resetForm();
};

  return (
    <Container style={{ height: `${height}px` }}>
      <Header>
        <h1 className="text-white text-lg font-medium">Manage Linked Staff</h1>
        <button onClick={handleClose}>
          <MdClose color="white" size={24} />
        </button>
      </Header>

      <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
        {({ values, setFieldValue, errors, touched, isSubmitting,handleChange }) => (
          <Form className="px-6 h-full flex flex-col justify-between">
            <ScrollableContent className="max-h-[calc(100dvh-120px)]">
              <Wrapper>
                {/* Owner Name */}
                <InputGroup>
                  <Label htmlFor="staffName">Staff Name *</Label>
                  <CategoryCard
                    title={values.staffName ||"staff"}
                    selectedCategory={selectedStaff}
                    onClick={() => setIsStaffModalOpen(true)}
                  />
                  {errors.staffName && touched.staffName && (
                    <p className="text-rose-600 text-sm mt-1">{errors.staffName}</p>
                  )}
                </InputGroup>

                {/* Mobile Number */}
                <InputGroup>
                  <Label htmlFor="mobile">Mobile Number *</Label>
                  <FieldWrappers className="bg-gray-100">
                    <MobileIcon />
                    <Field
                      type="text"
                      name="mobile"
                      id="mobile"
                      autoComplete="off"
                      maxLength={10}
                      placeholder="Enter 10-digit mobile number"
                      className="w-full pl-5"
                      // readOnly={!!selectedStaff}
                      readOnly
                    />
                  </FieldWrappers>
                  {errors.mobile && touched.mobile && (
                    <p className="text-rose-600 text-sm mt-1">{errors.mobile}</p>
                  )}
                </InputGroup>

                {/* Location Field */}
                {/* <InputGroup>
                  <Label>Select Location *</Label>

                  <FieldWrappers
                    onClick={() => setShowLocationModal(true)}
                    className="cursor-pointer flex justify-between items-center"
                  >
                    <span className="text-gray-600 text-sm">
                      {filteredLocations.find(
                        loc => loc.id === values.locationId
                      )?.name || "Select Location"}
                    </span>

                    <MdEdit className="w-4 h-4 text-gray-400" />
                  </FieldWrappers>

                  <div className="flex justify-end mt-2">
                    <Location
                      type="button"
                      onClick={() => setShowAddLocation(true)}
                    >
                      <MdAddLocationAlt className="mr-1 mt-0.5" />
                      Add Location
                    </Location>
                  </div>
                </InputGroup> */}

                <InputGroup>
                <Label>Visiting time</Label>
                <div className="flex gap-2">
                    {["any", "restriction"].map((option) => (
                    <button
                        key={option}
                        type="button"
                        className={`px-4 py-2 rounded-full border text-sm transition ${
                        timeOption === option
                            ? "bg-primary-color text-white"
                            : "bg-white text-gray-600"
                        }`}
                        onClick={() => setTimeOption(option)}
                    >
                        {option === "any" ? "Any Time" : "Restricted"}
                    </button>
                    ))}
                </div>
                </InputGroup>

                {/* {timeOption === "restriction" && (
                <InputGroup>
                    <Label>Select Time Slots</Label>
                    <div className="flex gap-2 flex-wrap">
                    {timeSlots.map((slot) => (
                        <button
                        key={slot}
                        type="button"
                        className={`px-4 py-2 rounded-full border text-sm transition ${
                            restrictedTimes === slot
                            ? "bg-primary-color text-white"
                            : "bg-white text-gray-600"
                        }`}
                        onClick={() => setRestrictedTimes(slot)}
                        >
                        {slot}
                        </button>
                    ))}
                    </div>
                </InputGroup>
                )} */}
                {timeOption === "restriction" && (
                <InputGroup>
                    <Label>Enter Time Slots</Label>
                      <FieldWrappers className="">
                      <Field
                        type="text"
                        name="restriction"
                        id="restriction"
                        autoComplete="off"
                        maxLength={30}
                        placeholder="12PM to 1PM"
                        className="w-full pl-3"
                      />
                    </FieldWrappers>
                    {errors.restriction && touched.restriction && (
                      <p className="text-rose-600 text-sm mt-1">{errors.restriction}</p>
                    )}
                </InputGroup>
                )}
                <InputGroup>
                <Label>Notes</Label>
                <Textarea
                    name="notes"
                    value={values.notes}
                    onChange={handleChange}
                />
                </InputGroup>
              </Wrapper>
            </ScrollableContent>

            <ActionSection>
              <SideCancelBtn type="button" onClick={handleClose}>
                Cancel
              </SideCancelBtn>
              {/* <SubmitBtn type="submit" disabled={isSubmitting}>
                Submit
              </SubmitBtn> */}
              <SubmitBtn type="submit" disabled={addAssignedStaffLoading}>
                {addAssignedStaffLoading ? "Submiting..." : "Submit"}
              </SubmitBtn>
            </ActionSection>

            {/* Owner Selection Modal */}
            <SelectItemModal
              isOpen={isStaffModalOpen}
              onClose={() => setIsStaffModalOpen(false)}
              onSelect={(staffList) => {
                setSelectedStaff(staffList);
                setFieldValue("staffName", staffList.name);
                setFieldValue("ownerId", staffList.id);
                setFieldValue("mobile", staffList.mobile);
              }}
              options={staffList}
              selectedItem={selectedStaff}
              title="Select Staff"
              searchPlaceholder="Search Staff..."
              idKey="id"
              nameKey="name"
              descriptionKeys={["mobile"]}
            />
            {/* <SelectLocationModal
              isOpen={showLocationModal}
              onClose={() => setShowLocationModal(false)}
              options={filteredLocations}
              selectedValue={values.locationId}
              onSelect={(val) => {
                setFieldValue("locationId", val);
                setShowLocationModal(false);
              }}
            /> */}
          </Form>
        )}
      </Formik>
    </Container>
  );
};

const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Textarea = tw.textarea`border border-gray-300 rounded p-2 w-full resize-none`;
const Location = tw.button`text-blue-500 text-sm flex hover:underline`;

export default LinkStaff;











// import { useState, useEffect, useMemo } from "react";
// import { MdClose } from "react-icons/md";
// import { FaRegCheckSquare, FaRegPlusSquare } from "react-icons/fa";
// import { GoSearch } from "react-icons/go";
// import tw from "tailwind-styled-components";
// import { ScrollableContent } from "../Styles/InputStyles";
// import { ProfileSection } from "../Styles/PageStyles";

// const LinkStaff = ({ selectedData, setIsLinkStaff, staffList }) => {

//     const [searchText, setSearchText] = useState("");
//     const [linkedStaffIds, setLinkedStaffIds] = useState([]);
//     const [staffWithLinkStatus, setStaffWithLinkStatus] = useState([]);

//     // Initialize linked staff IDs from selectedData.assignStaff
//     useEffect(() => {
//         if (selectedData?.assignStaff && selectedData.assignStaff.length > 0) {
//             const ids = selectedData.assignStaff.map(staff => staff.id);
//             setLinkedStaffIds(ids);
//         } else {
//             setLinkedStaffIds([]);
//         }
//     }, [selectedData]);

//     // Combine staffList with link status
//     useEffect(() => {
//         if (staffList && staffList.length > 0) {
//             const combined = staffList.map(staff => ({
//                 ...staff,
//                 isLinked: linkedStaffIds.includes(staff.id),
//             }));
//             setStaffWithLinkStatus(combined);
//         }
//     }, [staffList, linkedStaffIds]);

//     // Filter staff based on search
//     const filteredStaff = useMemo(() => {
//         if (!searchText.trim()) return staffWithLinkStatus;

//         const searchLower = searchText.toLowerCase();
//         return staffWithLinkStatus.filter(staff =>
//             staff.name?.toLowerCase().includes(searchLower)
//         );
//     }, [staffWithLinkStatus, searchText]);

//     // Handle toggle link status
//     const handleToggle = (staffId) => {
//         setLinkedStaffIds(prev => {
//             if (prev.includes(staffId)) {
//                 return prev.filter(id => id !== staffId);
//             } else {
//                 return [...prev, staffId];
//             }
//         });

//         // Update local state for immediate UI feedback
//         setStaffWithLinkStatus(prev =>
//             prev.map(staff =>
//                 staff.id === staffId
//                     ? { ...staff, isLinked: !staff.isLinked }
//                     : staff
//             )
//         );
//     };

//     return (
//         <Container>
//             <Header>
//                 <h1 className="text-white text-lg font-medium">Manage Linked Staff</h1>
//                 <button onClick={() => setIsLinkStaff(false)}>
//                     <MdClose color="white" size={24} />
//                 </button>
//             </Header>

//             <ProfileSection className="flex justify-between">
//                 <UserImageWrapper>
//                     <div className="flex flex-col gap-1">
//                         <span className="text-gray-600 text-sm font-medium flex items-center gap-2">
//                             {selectedData?.buildingName}
//                         </span>
//                         <span className="text-gray-400 text-xs flex items-center gap-1">
//                             {selectedData?.address}, {selectedData?.locationName} - {selectedData?.pinCode}
//                         </span>
//                     </div>
//                 </UserImageWrapper>

//             </ProfileSection>


//             {/* Search Bar */}
//             <div className="px-4 pt-4 relative">
//                 <div className="relative">
//                     <input
//                         type="text"
//                         placeholder="Search staff by name"
//                         value={searchText}
//                         onChange={(e) => setSearchText(e.target.value)}
//                         className="w-full px-8 h-12 py-2 border border-gray-200 rounded-md focus:outline-none focus:border-primary-color text-gray-800 placeholder-gray-300"
//                     />
//                     <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//                         <GoSearch className="w-4 h-4 text-gray-400" />
//                     </div>
//                     {searchText && (
//                         <button
//                             onClick={() => setSearchText("")}
//                             className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
//                         >
//                             <MdClose size={18} />
//                         </button>
//                     )}
//                 </div>
//             </div>

//             {/* Staff List */}
//             {staffWithLinkStatus.length > 0 && (
//                 <ScrollableContent className="max-h-screen overflow-y-auto px-6 py-4">
//                     {filteredStaff.length === 0 ? (
//                         <div className="text-center py-8">
//                             <div className="text-gray-400 mb-2">
//                                 <GoSearch size={32} className="mx-auto" />
//                             </div>
//                             <p className="text-gray-500">No staff found matching "{searchText}"</p>
//                             <button
//                                 onClick={() => setSearchText("")}
//                                 className="mt-2 text-primary-color hover:underline text-sm"
//                             >
//                                 Clear search
//                             </button>
//                         </div>
//                     ) : (
//                         <>
//                             {filteredStaff.map((staff) => (
//                                 <PropertyRow key={staff.id}>
//                                     <Label>{staff.name}</Label>
//                                     <button
//                                         onClick={() => handleToggle(staff.id)}
//                                     >
//                                         {staff.isLinked ? (
//                                             <FaRegCheckSquare
//                                                 size={20}
//                                                 className="text-primary-color font-normal text-sm"
//                                             />
//                                         ) : (
//                                             <FaRegPlusSquare
//                                                 size={20}
//                                                 className="text-gray-400 hover:text-gray-600 font-normal text-sm"
//                                             />
//                                         )}
//                                     </button>
//                                 </PropertyRow>
//                             ))}
//                         </>
//                     )}
//                 </ScrollableContent>
//             )}

//             {staffWithLinkStatus.length === 0 && (
//                 <div className="text-center py-12">
//                     <p className="text-gray-500">No staff available to link</p>
//                 </div>
//             )}
//         </Container>
//     );
// };

// const Container = tw.div`bg-white w-full h-full flex flex-col`;
// const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
// const PropertyRow = tw.div`flex items-center justify-between py-5 border-b`;
// const Label = tw.span`text-gray-600`;
// const UserImageWrapper = tw.div` flex items-center gap-2`;

// export default LinkStaff;